module.exports = __webpack_public_path__ + "static/ef-logo-tm3-1af7f9e5f41c58d58272101ddca969e9.svg";